import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import SelectionCheckbox from '../../Common/SelectionCheckbox';
import { useAppStore } from '../../../GlobalStore/GlobalStore';
import { getRelativePath } from '../../../Utils/misc/pathUtils';

interface SelectedContextItemProps {
    item: {
        filePath: string;
        isSelected: boolean;
    };
    onRemove: () => void;
    onToggle: () => void;
    isLastItem: boolean;
}

const SelectedContextItem: React.FC<SelectedContextItemProps> = ({
    item,
    onRemove,
    onToggle,
    isLastItem
}) => {
    const projectName = useAppStore((state: any) => state.environmentObj.projectName);
    const fileName = item.filePath.split(/[/\\]/).pop() || '';
    const relativePath = getRelativePath(item.filePath, projectName);
    return (
        <div
            onClick={onToggle}
            className={`flex items-center justify-between px-4 py-2 text-black dark:text-white hover:bg-neutral-200 dark:hover:bg-neutral-800 ${!isLastItem ? 'border-b border-neutral-300 dark:border-neutral-700' : ''}`}
            data-tooltip-id="main-tooltip"
            data-tooltip-content={relativePath}
            data-tooltip-place="right-start"
        >
            <span className="text-sm max-w-3/4 overflow-hidden text-ellipsis whitespace-nowrap block" style={{ direction: 'rtl', textAlign: 'left' }}>
                <span style={{ direction: 'ltr', display: 'inline-block' }}>
                    {fileName}
                </span>
            </span>
            <div className="flex items-center gap-2">
                <button
                    onClick={(e) => {
                        e.stopPropagation();
                        onRemove();
                    }}
                    className="flex mr-0.5 items-center justify-center w-5 h-5 rounded hover:bg-neutral-300 dark:hover:bg-neutral-700 text-neutral-400 hover:text-neutral-600 dark:text-neutral-500 dark:hover:text-neutral-400"
                >
                    <FontAwesomeIcon icon={faTimes} className="w-3.5 h-3.5" />
                </button>
                <SelectionCheckbox
                    isSelected={item.isSelected}
                    onChange={(e) => {
                        e.stopPropagation();
                        onToggle();
                    }}
                />
            </div>
        </div>
    );
};

export default SelectedContextItem;